module.exports = __webpack_public_path__ + "img/9.444e0554.png";